import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import Form from "react-bootstrap/Form";

import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";

import ThemeProvider from "react-bootstrap/ThemeProvider";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faHomeUser,
  faRoad,
  faMountain,
  faStopwatch20,
} from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";

function Profile() {
  return (
    <ThemeProvider
      breakpoints={["xxxl", "xxl", "xl", "lg", "md", "sm", "xs", "xxs"]}
      minBreakpoint="xxs"
    >
      <Container fluid="xxs">
        <Navbar id="container-nav" expand="lg">
          <Container fluid>
            <Navbar.Brand href="#">
              <Link to="/profile" aria-current="page">
                <FontAwesomeIcon icon={faHomeUser} className="user-icon" />
              </Link>
            </Navbar.Brand>
            <Navbar.Brand>
              <Link to="/userone" aria-current="page" id="name">
                DROP Cycling &trade;
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls="navbarScroll"
              className="navbar-toggler"
              id="border"
            >
              <FontAwesomeIcon icon={faBars} id="toggle" />
            </Navbar.Toggle>
            <Navbar.Collapse id="navbarScroll">
              <Nav
                className="me-auto my-2 my-lg-0"
                style={{ maxHeight: "100px" }}
                navbarScroll
              ></Nav>
              <Form className="d-flex" id="search">
                <Form.Control
                  type="search"
                  placeholder="Search"
                  className="me-2"
                  aria-label="Search"
                />
                <Button variant="outline-none" id="search-btn">
                  Search
                </Button>
              </Form>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <div className="user">
          <Row className="g-4">
            <Col sm={{ span: 10, offset: 1 }}>
              <p className="time-pagination">
                <FontAwesomeIcon icon={faStopwatch20} />
              </p>
            </Col>
          </Row>

          <Card className="card-design-time">
            <Row className="g-4">
              <Col sm={{ span: 12 }}>
                <p className="sub-topic-time">September &#8722; October</p>
              </Col>
            </Row>
          </Card>
          <Card className="card-design-time-two">
            <Row>
              <Col sm={{ span: 12 }}>
                <p className="time-header">Hills</p>

                <p className="basic-text-time">
                  <FontAwesomeIcon icon={faMountain} id="icon-space-time" />
                  Date: September 18 &#8722; October 8 | Elevation: 8,007ft|
                  Miles: 24.2mi | Location: Pikes Peak, Co
                </p>

                <p className="basic-text-time">
                  <FontAwesomeIcon icon={faMountain} id="icon-space-time" />
                  Date: September 18 &#8722; October 8 | Elevation: 4624ft|
                  Miles: 16.5mi | Location: Bear Camp, Or
                </p>

                <p className="basic-text-time">
                  <FontAwesomeIcon icon={faMountain} id="icon-space-time" />
                  Date: September 18 &#8722; October 8 | Elevation: 8,007ft|
                  Miles: 24.2mi | Location: Pikes Peak, Co
                </p>

                <p className="basic-text-time-divide">
                  <FontAwesomeIcon icon={faMountain} id="icon-space-time" />
                  Date: September 18 &#8722; October 8 | Elevation: 4,234ft |
                  Miles: 15.1mi | Location: Mt. Hood, Or
                </p>

                <p className="time-header">Road</p>

                <p className="basic-text-time">
                  <FontAwesomeIcon icon={faRoad} id="icon-space-time" />
                  Date: September 18 &#8722; October 8 | Elevation: -1,209ft
                  &#8722; +1,210ft | Miles: 35.9mi | Location: Cottage Grove, Or
                </p>

                <p className="basic-text-time">
                  <FontAwesomeIcon icon={faRoad} id="icon-space-time" />
                  Date: September 18 &#8722; October 8 | Elevation: -1,191ft
                  &#8722; +1,647ft | Miles: 50.5mi | Location: Forest Grove, Or
                </p>

                <p className="basic-text-time-divide-orford">
                  <FontAwesomeIcon icon={faRoad} id="icon-space-time" />
                  Date: September 18 &#8722; October 8 | Elevation: -3,033ft
                  &#8722; +3,028 | Miles: 60.9mi | Location: Port Orford, Or
                </p>
              </Col>
            </Row>
          </Card>
          <footer>
            <Row>
              <Col sm={{ span: 6, offset: 3 }}>
                <p className="copy">Copyright &copy; 2023</p>
              </Col>
            </Row>
          </footer>
        </div>
      </Container>
    </ThemeProvider>
  );
}

export default Profile;
